const NOTE_NUMBER_RE = /^\s*(\d+)\s*\./;

/** IXD 대목차 제목에서 note number를 추출한다. "12. 유형자산" → "12" */
export const parseChunkNoteNumber = (title: string): string | undefined =>
  title.match(NOTE_NUMBER_RE)?.[1];

/**
 * 표 이름 앞에 대목차 번호를 붙인다. ("12. 유형자산" 목차의 "장부금액" → "12. 장부금액")
 *
 * 블록마다 제목이 따로 서는 화면에서는 번호가 없으면 그 표가 어느 주석의 것인지
 * 블록만 보고 알 수 없다. 이름이 이미 번호로 시작하거나 목차에서 번호를 못 읽으면
 * 그대로 둔다 — "12. 12. 유형자산" 같은 중복을 만들지 않는다.
 */
export const withChunkNoteNumber = (
  chunkTitle: string,
  name: string,
): string => {
  const noteNumber = parseChunkNoteNumber(chunkTitle);
  if (!noteNumber || parseChunkNoteNumber(name)) return name;
  return `${noteNumber}. ${name}`;
};
